import { settingsAtom } from "core/shared";
import packageJson from "package.json";
import logo from "~/assets/images/footer/footer-logo.png";
import { Accordion } from "~/design-system/components/ui/accordion";
import { footerLinks } from "./data";
import { FooterAccordionItem } from "./FooterAccordionItem";
import { FooterColumn } from "./FooterColumn";
import { FooterSocialMedia } from "./FooterSocialMedia";

export function Footer() {
  const settings = settingsAtom.use("contact");

  const workingHoursArray = settings?.workingHours
    ? settings.workingHours
        .split("\n")
        .map((hour) => {
          const [label = "", value = ""] = hour.trim().split(/:\s*(.+)/);
          return { label, value };
        })
        .filter(({ label, value }) => label && value)
    : [];

  const footerSections = [
    {
      id: "pages",
      titleKey: "pages",
      type: "pages" as const,
      items: footerLinks.pages,
    },
    {
      id: "contact",
      titleKey: "contact",
      type: "contact" as const,
      items: footerLinks.contact,
    },
    {
      id: "openingHours",
      titleKey: "openingHours",
      type: "openingHours" as const,
      items: workingHoursArray,
    },
    // {
    //   id: "socialMedia",
    //   titleKey: "socialMedia",
    //   type: "socialMedia" as const,
    //   items: footerLinks.socialMedia,
    // },
  ];

  return (
    <footer className="bg-primary-light">
      <div className="container flex flex-col gap-10 py-10">
        <div className="flex items-center justify-center">
          <img src={logo} alt="logo" width={420} height={160} />
        </div>
        {/* Footer Links */}
        <div className="border-y py-10">
          {/* Mobile Accordion */}
          <div className="md:hidden">
            <Accordion type="multiple" className="w-full">
              {footerSections.map((section) => (
                <FooterAccordionItem
                  key={section.id}
                  value={section.id}
                  titleKey={section.titleKey}
                  type={section.type}
                  items={section.items}
                />
              ))}
            </Accordion>
            <FooterSocialMedia />
          </div>

          {/* Desktop Grid Layout */}
          <div className="hidden grid-cols-1 gap-8 md:grid md:grid-cols-2 lg:grid-cols-4">
            {footerSections.map((section) => (
              <FooterColumn
                key={section.id}
                titleKey={section.titleKey}
                type={section.type}
                items={section.items}
              />
            ))}
            <FooterSocialMedia />
          </div>
        </div>

        {/* Copyright */}
        <div className="flex items-center justify-center text-center">
          <p>
            <span>
              © {new Date().getFullYear()} by Nanni&apos;s Cakes. Crafted
              By{" "}
            </span>
            <a
              href="https://crafted-internet.com"
              target="_blank"
              rel="noreferrer noopener"
              className="text-orange-600 hover:underline"
            >
              Crafted Internet
            </a>
            , Crafted With Care{" "}
            <span className="text-xs text-gray-500">
              v{packageJson.version}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
